import { EntityState } from '../../store/store.utils';
import { Application } from '../../../../common/models/application.interface';
import { DownloadInfo } from './utils.selectors';

export interface UtilState {
    ui: {
        downloadInfo: DownloadInfo;
    };
    data: {
        application: EntityState<string, Application>;
    };
}

export const initialUtilState = {
    ui: {
        downloadInfo: {
            fileName: '',
            url: ''
        }
    },
    data: {
        application: {
            idMap: {},
            idSort: []
        }
    }
};
